"use client";

import React from "react";

export default function YearBg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 383 227"
      fill="none"
      className="absolute inset-0 w-full h-full"
    >
      <path
        d="M371.825 117.597C354.072 155.216 317.993 182.407 278.277 194.727C238.561 207.075 195.523 205.643 154.948 196.618C132.986 191.747 110.622 184.641 88.4304 188.366C63.2035 192.606 42.5294 210.112 23.2298 226.959C23.2012 226.988 23.1439 227.017 23.0866 226.988C23.0866 226.988 23.0675 226.988 23.0294 226.988C22.8576 226.759 22.6858 226.587 22.5139 226.358C21.8554 225.527 21.1968 224.696 20.5954 223.865H20.5668C-3.77245 191.947 -6.00594 145.79 11.2033 109.403C28.9567 71.7836 65.0361 44.5934 104.752 32.2733C144.468 19.9246 187.505 21.3571 228.08 30.3823C250.043 35.2531 272.407 42.3586 294.598 38.6339C319.825 34.3935 340.499 16.8875 359.799 0.0405192C359.827 0.0118678 359.885 -0.0167836 359.942 0.0118678H359.971C360.171 0.241079 360.314 0.412987 360.486 0.642198C361.145 1.47309 361.803 2.30398 362.405 3.13487H362.433C386.772 35.0525 389.006 81.2099 371.797 117.597H371.825Z"
        fill="#00542D"
      />
    </svg>
  );
}
